import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { inspectionService } from '../../services/inspection.service';

interface CancelJobModalProps {
    onClose: () => void;
    inspectionId: number;
    onCancelSuccess: () => void;
}

export default function CancelJobModal({ onClose, inspectionId, onCancelSuccess }: CancelJobModalProps): React.ReactElement {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleCancel = async () => {
        try {
            setLoading(true);
            setError(null);
            await inspectionService.cancelInspection(inspectionId);
            onCancelSuccess();
            onClose();
        } catch (err: any) {
            setError(err.response?.data?.error || 'Failed to cancel inspection');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-40 flex items-center justify-center p-6">
            <div className="bg-white p-6 rounded-lg z-50 relative w-full  max-w-[671px] min-h-[295px] max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center mb-7">
                    <h2 className="text-black-1 text-lg sm:text-xl md:text-[22px] xl:text-[24px] font-bold font-[Geist-Bold]">
                        Cancel Job
                    </h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-black text-xl">
                        <Icon
                            icon="gridicons:cross"
                            className="icon-color"
                            width={40}
                            height={20}
                        />
                    </button>
                </div>
                <div className='flex flex-col justify-between flex-grow'>
                    <div className="">
                        <p className="text-[#444444] font-[Acumin-Regular] text-sm md:text-base mb-2 !leading-[1.7]">
                            You’re about to cancel the current inspection in progress.<br />This action will pause any fault detection and discard partial checklist inputs.
                            Are you sure you want to cancel and start a new job instead?
                        </p>
                        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    </div>

                    <div className="flex justify-end space-x-4">

                        <button
                            onClick={handleCancel}
                            disabled={loading}
                            className="px-4 py-2 text-[#8F92A1]  disabled:opacity-50"
                        >
                            <span className=" font-medium  text-base md:text-lg font-[Geist-Medium]">
                                {loading ? "Cancelling..." : "Cancel Job"}
                            </span>
                        </button>
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-blue text-white rounded text-base md:text-lg font-[Geist-Medium]"
                            disabled={loading}
                        >
                            Continue with Inspection
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};